import { get, post, put } from "./http.service";

const CountryAddressFieldService = {
  get: id => get(`countryAddressField/${id}`),
  create: body => post(`countryAddressField`, body),
  update: (id, body) => put(`countryAddressField/${id}`, body),
  getAll: () => get(`countryAddressField`),
};
export default CountryAddressFieldService;
